"use strict";
(function (module) {
    'use strict';
    module.factory('prDeleteReportModal', [
        'qstrap.modal',
        function (modal) {
            function show() {
                return modal({
                    show: true,
                    controller: 'prDeleteReportController',
                    title: '<i class="icon icon-caution-lg"></i><span translate>DELETE_REPORT</span>',
                    content: '<div qstrap.spin spin-if="$ctrl.spin">' +
                        '<p translate>DELETE_REPORT_WARNING</p>' +
                        '<p translate>WARNING_CANNOT_UNDONE</p>' +
                        '</div>',
                    buttons: [
                        '<button class="btn btn-danger" ng-disabled="$ctrl.spin" ng-click="$ctrl.deleteReport()">' +
                            '<i class="icon btn-icon-x"></i>' +
                            '<span translate>DELETE_THIS_REPORT</span>' +
                            '</button>',
                        '<button class="btn btn-hover" ng-click="close()" translate>CANCEL</button>'
                    ]
                });
            }
            return {
                show: show
            };
        }
    ]);
}(angular.module('qualtrics.pr')));
